module.exports = __webpack_public_path__ + "media/images/home/card_i_belong-21c7baaaf618a9c83234c6d537c9bd11.jpg";